import React, { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import styles from './ResponsiveCarousel.module.scss';
import type { CarouselProps } from 'react-responsive-carousel';
// CSS must be imported statically for Next.js to process it
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const CN = 'carousel';
const cx = classnames.bind(styles);

// Lazy load carousel library only (CSS is already loaded)
let CarouselComponent: React.ComponentType<Partial<CarouselProps>> | null = null;

const loadCarousel = async (): Promise<void> => {
  if (!CarouselComponent) {
    const carouselModule = await import('react-responsive-carousel');
    CarouselComponent = carouselModule.Carousel;
  }
};

export const ResponsiveCarousel: React.FC<Partial<CarouselProps>> = ({
  children,
  className,
  ...rest
}) => {
  const [ isLoaded, setIsLoaded ] = useState(false);
  const [ Carousel, setCarousel ] = useState<React.ComponentType<Partial<CarouselProps>> | null>(null);

  useEffect(() => {
    loadCarousel().then(() => {
      if (CarouselComponent) {
        setCarousel(() => CarouselComponent);
        setIsLoaded(true);
      }
    });
  }, []);

  if (!isLoaded || !Carousel) {
    return <div className={ cx(CN, className) }>{ children }</div>;
  }

  return (
    <Carousel
      className={ cx(CN, className) }
      { ...rest }
    >
      { children }
    </Carousel>
  );
};
